module.exports = __webpack_public_path__ + "42bdc8917851490eadba6586e53bf312.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/yellow_cured.png
 ** module id = 1080
 ** module chunks = 0
 **/